import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { formatDate, formatDateTime } from 'utils/Formatters';
import { find, isEmpty, map, groupBy } from 'lodash';

class AccountPlayersReportDetailsModal extends React.Component {
  render() {
    const {report} = this.props

    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>{this.props.t('reports.details.title')}</b></h2>
        <hr className='u-margin-top--zero'/>
        <table className='o-table o-table--bordered'>
          <tbody>
            <tr>
              <th>{this.props.t('reports.details.requestedAt')}</th>
              <td>{formatDateTime(report.createdAt)}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.partners')}</th>
              <td>{this.renderRelated('partners')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.groups')}</th>
              <td>{this.renderRelated('groups')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.cohorts')}</th>
              <td>{this.renderCohorts()}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.adults')}</th>
              <td>{this.renderRelated('accounts')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.includeArchived')}</th>
              <td>{report.params.archived ? this.props.t('reports.details.yes') : this.props.t('reports.details.no')}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.startDate')}</th>
              <td>{formatDate(report.params.start)}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.endDate')}</th>
              <td>{formatDate(report.params.end)}</td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.query')}</th>
              <td>{report.params.q}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderRelated(related) {
    const collection = this.props[related]

    return this.relatedIds(related).map((id) => {
      return find(collection, p => p.value == id).label
    }).join(', ');
  }

  relatedIds(relatedAttribute) {
    const {report} = this.props

    if (isEmpty(report.params[relatedAttribute])) { return [] }

    return report.params[relatedAttribute].split(',').map((id) => {
      return parseInt(id, 10);
    })
  }

  renderCohorts() {
    return map(this.groupedReportCohorts(), (cohorts, groupName) => {
      return (
        <div key={groupName}>
          {
            [
              groupName,
              cohorts.map(c => c.name).join(", "),
            ].join(": ")
          }
        </div>
      )
    });
  }

  groupedReportCohorts() {
    return groupBy(this.reportCohorts(), 'group_name');
  }

  reportCohorts() {
    return this.relatedIds("cohorts").map((id) => {
      return find(this.cohorts(), p => p.id == id)
    });
  }

  cohorts() {
    return map(this.props.cohorts, (group, groupName) => { return group }).flat();
  }
}

const mapStateToProps = (state) => {
  return {
    partners: state.filters.partners,
    groups: state.filters.groups,
    cohorts: state.filters.cohorts,
    accounts: state.filters.accounts,
  }
}

AccountPlayersReportDetailsModal.propTypes = {
  report: PropTypes.object.isRequired,
  partners: PropTypes.arrayOf(PropTypes.object).isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  cohorts: PropTypes.object.isRequired,
  accounts: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default connect(mapStateToProps, null)(withTranslation()(AccountPlayersReportDetailsModal))
